export const COSMETIC_SPECIALTIES = [
  'Aesthetic Nurse',
  'Aesthetic Physician',
  'Dermatologist',
  'Plastic Surgeon',
  'Cosmetic Surgeon',
  'Nurse Injector',
  'Nurse Practitioner - Aesthetics',
  'Physician Assistant - Aesthetics',
  'Esthetician',
  'Medical Aesthetician',
  'Cosmetic Dermatologist',
  'Facial Plastic Surgeon',
  'Oculoplastic Surgeon',
  'Medical Spa Director',
  'Laser Specialist',
  'Anti-aging Specialist',
  'Neurotoxin Specialist',
  'Filler Specialist',
  'Microblading Artist',
  'Permanent Makeup Artist',
  'Body Contouring Specialist',
  'CoolSculpting Provider',
  'SculpSure Provider',
  'Ultherapy Provider',
  'HydraFacial Provider',
  'Chemical Peel Specialist',
  'Microneedling Specialist',
  'Tattoo Removal Specialist',
  'Hair Restoration Specialist',
  'Wellness Practitioner',
];

export const getFilteredSpecialties = (searchTerm: string): string[] => {
  if (!searchTerm.trim()) return COSMETIC_SPECIALTIES;

  const term = searchTerm.toLowerCase();
  return COSMETIC_SPECIALTIES.filter((specialty) => specialty.toLowerCase().includes(term));
};
